// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-buttons p{color:#6c6c6c;font-size:14px;margin-bottom:22px}.social-buttons__container{display:flex;justify-content:center}.social-buttons__button{--size:44px;margin:0 8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
